import { Vector2 } from "../../../../maths/Vector2";
export class Web2DGraphicWholeBuffer {
    constructor() {
        this._num = 0;
        this._updateRange = new Vector2(100000000, -100000000);
    }
    _modifyOneView(view) {
        this._updateRange.y = Math.max(view.start + view.length, this._updateRange.y);
        this._updateRange.x = Math.min(view.start, this._updateRange.x);
    }
    addDataView(view) {
        view._next = null;
        view._prev = null;
        if (!this._first) {
            this._first = view;
        }
        if (this._last) {
            this._last._next = view;
            view._prev = this._last;
        }
        view.owner = this;
        this._last = view;
        this._num++;
    }
    removeDataView(view) {
        view.owner = null;
        if (view._prev) {
            view._prev._next = view._next;
        }
        if (view._next) {
            view._next._prev = view._prev;
        }
        if (view == this._first) {
            this._first = view._next;
        }
        if (view == this._last) {
            this._last = view._prev;
        }
        view._next = null;
        view._prev = null;
        this._updateRange.x = Math.min(view.start, this._updateRange.x);
        this._updateRange.y = Math.max(view.start + view.length, this._updateRange.y);
        this._num--;
    }
    destroy() {
        this._first = null;
        this._last = null;
        this._dataView = null;
        this.arrayBuffer = null;
    }
}
export class Web2DGraphicsVertexBuffer extends Web2DGraphicWholeBuffer {
    resetData(byteLength) {
        this.arrayBuffer = new ArrayBuffer(byteLength);
        let newData = new Float32Array(this.arrayBuffer);
        if (this._dataView) {
            newData.set(this._dataView);
        }
        this._dataView = newData;
        this._needResetData = true;
    }
    _upload() {
        if (this._needResetData) {
            let view = this._first;
            while (view) {
                view._updateView(this._dataView);
                view = view._next;
            }
            this.buffer.setData(this.arrayBuffer, 0, 0, this.arrayBuffer.byteLength);
            this._needResetData = false;
        }
        else {
            if (this._updateRange.y <= this._updateRange.x)
                return;
            this.buffer.setData(this.arrayBuffer, this._updateRange.x * 4, this._updateRange.x * 4, (this._updateRange.y - this._updateRange.x) * 4);
        }
        this._updateRange.setValue(100000000, -100000000);
    }
}
export class Web2DGraphicsIndexBuffer extends Web2DGraphicWholeBuffer {
    resetData(byteLength) {
        this.arrayBuffer = new ArrayBuffer(byteLength);
        let newData = new Uint16Array(this.arrayBuffer);
        if (this._dataView) {
            newData.set(this._dataView);
        }
        this._dataView = newData;
        this._needResetData = true;
    }
    _upload() {
        if (!this._num)
            return;
        let view = this._first;
        let start = 0;
        let length = 0;
        let geometry = view._geometry;
        let needUpdate = false;
        let uploadStart = this._needResetData ? 0 : this._updateRange.x;
        let mark = 0;
        while (view) {
            mark++;
            if (geometry != view._geometry) {
                if (needUpdate) {
                    geometry.clearRenderParams();
                    geometry.setDrawElemenParams(length, start * 2);
                }
                geometry = view._geometry;
                start = start + length;
                length = 0;
            }
            start = start + length;
            needUpdate = this._needResetData || start >= uploadStart;
            if (needUpdate) {
                view.start = start;
                view._updateView(this._dataView);
            }
            length += view.length;
            view = view._next;
        }
        if (needUpdate) {
            geometry.clearRenderParams();
            geometry.setDrawElemenParams(length, start * 2);
        }
        let len = this._last.start + this._last.length - uploadStart;
        let offset = uploadStart * 2;
        offset = Math.floor(offset / 4) * 4;
        this.buffer.setData(this.arrayBuffer, offset, offset, len * 2 + (uploadStart * 2 - offset));
        this._needResetData = false;
    }
    _modifyOneView(view) {
        if (view._prev) {
            view.start = view._prev.start + view._prev.length;
        }
        else {
            view.start = 0;
        }
        super._modifyOneView(view);
    }
}
export class Web2DGraphicsIndexBatchBuffer extends Web2DGraphicsIndexBuffer {
    _upload() {
        let view = this._first;
        let uploadStart = this._needResetData ? 0 : this._updateRange.x;
        while (view) {
            if (this._needResetData || view.start >= uploadStart) {
                view._updateView(this._dataView);
            }
            view = view._next;
        }
        let len = this._last.start + this._last.length - uploadStart;
        if (len == 0)
            return;
        let offset = uploadStart * 2;
        offset = Math.floor(offset / 4) * 4;
        let dataLength = len * 2 + (uploadStart * 2 - offset);
        if (dataLength + offset > this.arrayBuffer.byteLength) {
            offset -= (dataLength + offset - this.arrayBuffer.byteLength);
        }
        this.buffer.setData(this.arrayBuffer, offset, offset, dataLength);
        this._needResetData = false;
    }
    _modifyOneView(view) {
        this.addDataView(view);
        super._modifyOneView(view);
        if (view._geometry) {
            view._geometry.clearRenderParams();
            view._geometry.setDrawElemenParams(view.length, view.start * 2);
        }
    }
    clearBufferViews() {
        this._first = null;
        this._last = null;
        this._num = 0;
        this._updateRange.setValue(100000000, -100000000);
    }
    _resetData(byteLength) {
        super.resetData(byteLength);
    }
}
